<p-card class="bottom-padding">
  <div class="flex flex-col gap-8">
    <!-- Countdown Timer -->
    <div class="flex flex-col items-center gap-[18px]">
      <span class="text-body-md font-semibold">{{ getCountdownTitle() | translate }}</span>

      <!-- Countdown Display -->
      <div class="flex items-center justify-center gap-2 text-white">
        <div class="countdown-box-mobile rounded-lg w-[53px] h-[47px] flex flex-col items-center justify-center">
          <span class="text-body-md font-bold">{{
            countdown().days.toString().padStart(2, '0')
            }}</span>
          <span class="text-caption-sm text-text-secondary">{{
            'projectInsight.countdown.days' | translate
            }}</span>
        </div>
        <span class="text-xl-paragraph font-bold leading-[1.5]">:</span>
        <div class="countdown-box-mobile rounded-lg w-[53px] h-[47px] flex flex-col items-center justify-center">
          <span class="text-body-md font-bold">{{
            countdown().hours.toString().padStart(2, '0')
            }}</span>
          <span class="text-caption-sm text-text-secondary">{{
            'projectInsight.countdown.hours' | translate
            }}</span>
        </div>
        <span class="text-xl-paragraph font-bold leading-[1.5]">:</span>
        <div class="countdown-box-mobile rounded-lg w-[53px] h-[47px] flex flex-col items-center justify-center">
          <span class="text-body-md font-bold">{{
            countdown().minutes.toString().padStart(2, '0')
            }}</span>
          <span class="text-caption-sm text-text-secondary">{{
            'projectInsight.countdown.minutes' | translate
            }}</span>
        </div>
        <span class="text-xl-paragraph font-bold leading-[1.5]">:</span>
        <div class="countdown-box-mobile rounded-lg w-[53px] h-[47px] flex flex-col items-center justify-center">
          <span class="text-body-md font-bold">{{
            countdown().seconds.toString().padStart(2, '0')
            }}</span>
          <span class="text-caption-sm text-text-secondary">{{
            'projectInsight.countdown.seconds' | translate
            }}</span>
        </div>
      </div>
    </div>

    <!-- Progress Bar Section -->
    <div class="flex flex-col items-start gap-5 lg:gap-6">
      <div class="flex flex-col gap-3 lg:gap-5 w-full">
        <div class="h-5 lg:h-6 rounded-full relative progress-wrapper">
          <p-progressBar [value]="progressPercentage()" [style]="{ height: '100%' }">
            <ng-template #content>
              <span class="text-label-md-semibold">{{ progressPercentage() }}%</span>
            </ng-template>
          </p-progressBar>

          @if (softCapPercentage() > 0) {
          <div class="soft-cap-indicator absolute" [style.left.%]="softCapPercentage()"></div>
          }
        </div>

        <div class="flex justify-between items-start lg:items-end w-full">
          <div class="flex flex-col gap-1 items-start">
            <span class="text-body-sm text-text-secondary">{{
              'projectInsight.progress.softCap' | translate
              }}</span>
            <span class="text-body-md font-semibold" [class.text-cap-amount-success]="isSoftCapReached()">
              {{ (project().softCap || 0) | currencyFormat }} USDT
            </span>
          </div>
          <div class="flex flex-col gap-1 items-end">
            <span class="text-body-sm text-text-secondary">{{
              'projectInsight.progress.hardCap' | translate
              }}</span>
            <span class="text-body-md font-semibold" [class.text-cap-amount-success]="isHardCapReached()">
              {{ (project().hardCap || 0) | currencyFormat }} USDT
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-card>
